import { useAtomValue } from 'jotai';

import { VisitorState, visitorStateAtom } from '../../state';
import { JoinSessionButton } from './JoinSessionButton';
import { useAdmissionTrackingEvents } from './useAdmissionTrackingEvents';
import { useVisitorConnectRoomCallback } from './useVisitorConnectRoomCallback';

export function JoinSessionButtonWrapper() {
  const connectRoom = useVisitorConnectRoomCallback();
  const isLoading = useAtomValue(visitorStateAtom) === VisitorState.JOINING;
  const { trackJoinSessionClicked } = useAdmissionTrackingEvents();

  return (
    <JoinSessionButton
      onJoin={() => {
        connectRoom();
        trackJoinSessionClicked();
      }}
      isLoading={isLoading}
    />
  );
}
